<template>
  <b-dropdown
    ref="dropdown"
    :variant="design"
    v-bind="$attrs"
    v-on="mountEventListeners"
    @close="closeDropdown">
    <template #button-content>
      <coozzy-reply-icon v-if="icon === 'reply'" />
      <slot
        v-else-if="$slots['custom-text']"
        name="custom-text" />
      <span v-else>{{ text }}</span>
    </template>

    <slot />
  </b-dropdown>
</template>

<script>
import CoozzyReplyIcon from '@/framework/components/icons/CoozzyReplyIcon.vue'

export default {
  name: 'CoozzyDropdown',
  components: { CoozzyReplyIcon },
  inheritAttrs: false,
  props: {
    icon: {
      type: String,
      default: ''
    },
    design: {
      type: String,
      default: 'default'
    },
    text: {
      type: String,
      default: ''
    }
  },
  computed: {
    mountEventListeners() {
      return this.$listeners
    }
  },
  methods: {
    closeDropdown(e) {
      // Check if the click occurred outside the dropdown
      if (this.$refs.dropdown && !this.$refs.dropdown.$el.contains(e.target)) {
        e.preventDefault()
      }
    }
  }
}
</script>

<style lang="scss" scoped>
  :deep(.btn-default) {
    color: $color-bg-white;
    background-color: $color-bg-green-light;
    border-color: $color-bg-green-light;

    &:hover:not([disabled]) {
      color: $color-bg-white;
      background-color: $color-bg-green;
      border-color: $color-bg-green;
    }
  }

  :deep(.btn-green) {
    color: #fff;
    background-color: $color-primary;
    border-color: $color-primary;
  }
  :deep(.btn-green):hover {
    color: #fff;
    background-color: $color-primary;
    border-color: $color-primary;
  }

  :deep(ul.dropdown-menu) {
    box-shadow: 1px 1px 6px #ccc;
  }
</style>
